import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import ContactUs from "../components/ContactUs";

const Home = () => {
  return (
    <div>
      <Hero></Hero>
      <Services></Services>
      <About></About>
      
    </div>
  );
};

export default Home;
